import styled from 'styled-components';
import {
  Popover as ReactStrapPopover,
  PopoverHeader as ReactStrapPopoverHeader,
  PopoverBody as ReactStrapPopoverBody,
} from 'reactstrap';

const getPopoverSurface = ({ theme, variant }) =>
  variant === 'danger'
    ? theme.colors.dangerSecondary
    : theme.colors.semantic.surface.card;

const getPopoverBorderColor = ({ theme, variant }) =>
  variant === 'danger'
    ? theme.colors.danger500
    : theme.colors.semantic.border.default;

const getPopoverTextColor = ({ theme, variant }) =>
  variant === 'danger'
    ? theme.colors.semantic.text.inverse
    : theme.colors.semantic.text.primary;

export const Popover = styled(ReactStrapPopover)`
  .popover {
    display: flex;
    z-index: 10000;
    background-color: ${getPopoverSurface};
    border: 1px solid ${getPopoverBorderColor};
    box-shadow: 0 8px 20px ${({ theme }) => theme.colors.blackShades(0.2)};
  }

  .customInner {
    display: flex;
    flex-direction: column;
    min-width: 400px;
  }

  .customPopper {
    min-width: 420px;
    padding: 10px;
  }
`;

export const PopoverHeader = styled(ReactStrapPopoverHeader)`
  display: flex;
  justify-content: space-between;
  background-color: transparent;
  border-bottom: ${props =>
    props.variant === 'danger'
      ? 'none'
      : `1px solid ${getPopoverBorderColor(props)}`};

  font-size: 20px;
  color: ${getPopoverTextColor};
`;

export const PopoverBody = styled(ReactStrapPopoverBody)`
  flex: 1;
  padding: 20px;
  color: ${getPopoverTextColor};
`;

export const PopoverFooter = styled.div`
  padding: 10px 20px;
  color: ${getPopoverTextColor};
  border-top: ${props =>
    props.variant === 'danger'
      ? 'none'
      : `1px solid ${getPopoverBorderColor(props)}`};
`;
